import { render, staticRenderFns } from "./feature-move-copy.vue?vue&type=template&id=8bb702d0"
import script from "./feature-move-copy.vue?vue&type=script&lang=js"
export * from "./feature-move-copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2251928234/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bb702d0')) {
      api.createRecord('8bb702d0', component.options)
    } else {
      api.reload('8bb702d0', component.options)
    }
    module.hot.accept("./feature-move-copy.vue?vue&type=template&id=8bb702d0", function () {
      api.rerender('8bb702d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/feature-move-copy.vue"
export default component.exports